import { MapPinOff, Zap } from "lucide-react";

import { cn } from "@/lib/utils";
import { Badge } from "components/ui/badge";
import { Checkbox } from "components/ui/checkbox";
import { formatDate } from "components/helpers";
import { objToStrList } from "components/CaseMap/helpers";

const Field = ({ label, value }) => (
  <div className="tw:flex tw:gap-1 tw:min-w-0">
    <span className="tw:shrink-0 tw:text-(--color-text-muted)">{label}</span>
    <span className="tw:truncate tw:text-(--color-text-primary)">
      {value ? value : "—"}
    </span>
  </div>
);

export function CaseMapSidebarRow({
  machine,
  selected,
  notOnMap,
  onSelect,
  selectable,
  checked,
  onToggleChecked,
}) {
  return (
    // The checkbox is a sibling of the button rather than inside it: nesting one
    // interactive control in another swallows its clicks and is invalid markup.
    <div
      className={cn(
        "tw:flex tw:w-full tw:items-start tw:gap-2 tw:border-b tw:border-(--color-border) tw:px-3 tw:py-2 tw:text-xs tw:transition-colors tw:hover:bg-(--color-surface-raised)",
        selected && "tw:bg-(--color-surface-raised)"
      )}
      style={
        selected
          ? { boxShadow: "inset 3px 0 0 var(--color-highlight)" }
          : undefined
      }
    >
      {selectable && (
        <Checkbox
          checked={checked}
          onCheckedChange={() => onToggleChecked(machine.id)}
          aria-label={`Select machine ${machine.machine_id}`}
          className="tw:mt-1 tw:shrink-0"
        />
      )}

      <button
        type="button"
        aria-current={selected}
        onClick={() => onSelect(machine.id)}
        className="tw:flex tw:min-w-0 tw:flex-1 tw:flex-col tw:gap-1 tw:text-left"
      >
        <div className="tw:flex tw:items-center tw:gap-2 tw:min-w-0">
          <span className="tw:truncate tw:font-medium tw:text-sm tw:text-(--color-text-primary)">
            {machine.machine_id}
          </span>
          {notOnMap && (
            <Badge
              variant="outline"
              aria-label="Not on map"
              className="tw:shrink-0 tw:gap-1 tw:bg-yellow-50 tw:text-yellow-700 tw:dark:bg-yellow-950 tw:dark:text-yellow-300"
            >
              <MapPinOff className="tw:size-3" />
            </Badge>
          )}
          <Badge variant="secondary">
            {machine.machine_approval_status || "unset"}
          </Badge>
          <Badge variant="outline">{`auto: ${machine.automation_status}`}</Badge>
        </div>

        <Field label="Email:" value={objToStrList(machine.email_domains)} />
        <Field
          label="Computer:"
          value={objToStrList(machine.computer_domains)}
        />
        <Field
          label="Last event:"
          value={machine.last_event ? formatDate(machine.last_event) : null}
        />
        <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-1.5">
          <Zap className="tw:size-3 tw:text-(--color-text-muted)" />
          <span className="tw:text-(--color-text-primary)">
            {machine.num_events ?? 0} events
          </span>
        </div>
      </button>
    </div>
  );
}
